export const enum UrlMap {
  USER_LOGIN = '/pica8-sso/auth/account/login',
  GET_USER_ROLE = '/license/user/info',
  POST_CHANGE_PASSWORD = '/license/user/change/password',
  POST_CHANGE_USER_PASSWORD = '/license/user/password/change',
  GET_TICKET_JWT = '/pica8-sso/customer/getTicketJwt',
  LOGIN_OUT = '/pica8-sso/auth/account/logout',
}
